/**
 * The asterisk of a field the server already refuses when it is empty (W11).
 *
 * It does not create the rule - `changedBy` is `z.string().min(1)` on the
 * server, and an empty send has always left as a 400. It says it before the
 * click, which is the only moment it can still change anything.
 *
 * `danger` is semantic here and never decorative, which is what keeps the
 * colour rule intact: it marks a field whose absence is a refusal. The mark
 * itself is hidden from a screen reader - `aria-required` on the input carries
 * the information, an asterisk read aloud carries nothing.
 */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="text-danger">
      {' '}
      *
    </span>
  );
}
